import React, { useEffect } from 'react'
import { LayoutSection } from '../core/layout-section'
import { HeaderSection } from '../core/header-section'
import { Box, Breakpoint, Button, useTheme } from '@mui/material';
import { Logo } from 'src/components/logo';
import { Link } from 'react-router';
import { useStore } from 'src/store/StoreContext';
import { Menu } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Dashboard, ExpandLess, ExpandMore } from '@mui/icons-material';
import Footer, { getIcon } from './footer';
import { observer } from 'mobx-react-lite';
import { AccountPopover } from '../components/account-popover';
import { bgBlur, varAlpha } from 'src/theme/styles';

const HomeLayout = observer(({ children }: { children: React.ReactNode }) => {
    const store = useStore();
    
    const layoutQuery: Breakpoint = 'md';
    const theme = useTheme();
    // const services = store?.home.services ?? [];
    // const groupedServices = services.length > 3 ? [
    //     services.slice(0, 3),
    //     services.slice(3, services.length)
    // ] : [services];
    const services =
    store?.home.services?.filter(
        (service) =>
            Array.isArray(service.subService) &&
            service.subService.length > 0
    ) ?? [];

const groupedServices =
    services.length > 3
        ? [
            services.slice(0, 3),
            services.slice(3, services.length)
        ]
        : [services];

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenuOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <LayoutSection headerSection={
            <HeaderSection
                layoutQuery={layoutQuery}
               
                elevation={4}
                position={location.pathname === '/home' ? 'fixed' : 'relative'}
                slots={{
                    leftArea: <Logo href={!store?.user.user ? '/' : `/${store?.user.user?.role.toLowerCase()}`} />,
                    rightArea: [
                        <Box display={{ xs: 'none', md: 'flex' }}>
                            {location.pathname === '/home' && services.length > 0 && [
                                ...(groupedServices[0].map((x, idx) => <Button
                                    key={`Button-${idx}`}
                                    disableFocusRipple
                                    disableTouchRipple
                                    disableRipple
                                    disableElevation
                                    size='small'
                                    component={Link}
                                    to={`service/${x.id}`}
                                    variant='text'
                                    color='primary'
                                    sx={{ mr: 1, '&:hover': { backgroundColor: 'transparent', color: 'success.main' } }}
                                >
                                    {x.title}
                                </Button>)),
                                (groupedServices.length > 1 && groupedServices[1].length > 0 &&
                                    <><Button
                                        disableFocusRipple
                                        disableTouchRipple
                                        disableRipple
                                        disableElevation
                                        size='small'
                                        color="primary"
                                        sx={{
                                            '&:hover': {
                                                backgroundColor: 'inherit',
                                                color: 'success.main',
                                                boxShadow: 'none',
                                            },
                                            '&:focus': {
                                                outline: 'none',
                                                boxShadow: 'none',
                                            },
                                        }}
                                        onClick={handleMenuOpen}
                                        endIcon={Boolean(anchorEl) ? <ExpandLess /> : <ExpandMore />}
                                    >
                                        {'Referrals'}
                                    </Button>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            {groupedServices[1].map((child) => (
                                                <MenuItem
                                                    sx={{
                                                        color: 'primary.main',
                                                        fontWeight: 500,
                                                        '&:hover': {
                                                            color: 'success.main',
                                                        },
                                                    }}
                                                    key={child.title}
                                                    onClick={handleMenuClose}
                                                    component={Link}
                                                    to={`service/${child.id}`}
                                                >
                                                    {child.title}
                                                </MenuItem>
                                            ))}
                                        </Menu></>

                                ),
                            ]}
                        </Box>,
                        (!store?.user.user ?
                            <>{location.pathname !== '/login' &&
                                <Button
                                    disableFocusRipple
                                    disableTouchRipple
                                    disableRipple
                                    size='small'
                                    component={Link}
                                    to='login'
                                    variant='text'
                                    color='primary'
                                    sx={{ '&:hover': { backgroundColor: 'transparent', color: 'success.main' } }}
                                >
                                    Login
                                </Button>}</> : <AccountPopover data={[
                                    {label: 'Dashboard',
                                    href: `/${store?.user?.user?.role.toLowerCase()}`,
                                    icon: getIcon('fluent-color:news-24')}
                                ]} />)]
                }}
                component={'nav'}
                color='transparent'
                slotProps={{
                    container: {
                        maxWidth: 'xl'
                    },
                    toolbar:{
                        sx:{
                            backgroundColor: bgBlur({
                              color: varAlpha(
                                theme.vars.palette.background.defaultChannel,
                                0.8
                              ),
                            }),
                            transition: 'background-color 0.3s',
                          }
                    }
                }}
            />}
            footerSection={<Footer />}>
            {children}
        </LayoutSection>
    )
});

export default HomeLayout